export const getIsDesktopBrowser = () => {
    const { userAgent } = window.navigator;
    return !(/Android|webOS|iPhone|iPad|iPod|BlackBerry|Windows Phone/.test(userAgent));
};

export const getIsIOSDevice = () => {
    const { userAgent } = window.navigator;
    return (/iPhone|iPad|iPod|Mac/.test(userAgent));
};
